import { SubscriptionCancellation } from '../../../models/reports/admin-report/subscription-cancellation.model';
import {AbstractReportAdminPmsApiService} from "../abstract-report-admin.service";

/**
 * @class SubscriptionCancellationPmsApiService
 * @abstract
 * @extends {AbstractReportAdminPmsApiService<SubscriptionCancellation>}
 */
export class SubscriptionCancellationPmsApiService extends AbstractReportAdminPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/admin-reports/subscription-cancellation';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {SubscriptionCancellation}
     * @protected
     */
    newModel(attributes, ...params) {

        return new SubscriptionCancellation(attributes);
    }
}



// WEBPACK FOOTER //
// ./src/pms-api/services/reports/admin-report/subscription-cancellation.service.js